import BackButton from "@/components/buttons/back-button"
import { PUBLIC_PATHS } from "@/constants/public-path"
import { authStore } from "@/routes/login/auth-store"
import { useLocation } from "react-router-dom"

const Headline = ({ point, title, description }) => {
  const { role } = authStore()
  const location = useLocation()

  return (
    <header className="mb-10 ml-1">
      <div className="flex items-center gap-1 mb-1.5">
        {(PUBLIC_PATHS.includes(location.pathname) || role === "ADMIN") && (
          <BackButton className="-ml-2 cursor-pointer" />
        )}
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] ml-0.5 text-blue-700">
            {point}
          </p>
          <h1 className="-mt-0.5 text-h4 font-bold text-slate-800">{title}</h1>
        </div>
      </div>
      <p className="text-slate-500 text-sm">{description}</p>
    </header>
  )
}

export default Headline
